import React, { Component } from "react";
import axios from "axios";
import { apiHost } from "../api/apiClient";

const turnstileScriptId = "cloudflare-turnstile-script";
let turnstileScriptPromise = null;

const loadTurnstileScript = () => {
  if (window.turnstile) return Promise.resolve();
  if (turnstileScriptPromise) return turnstileScriptPromise;

  turnstileScriptPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(turnstileScriptId);
    if (existingScript) {
      existingScript.addEventListener("load", resolve, { once: true });
      existingScript.addEventListener("error", reject, { once: true });
      return;
    }

    const script = document.createElement("script");
    script.id = turnstileScriptId;
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return turnstileScriptPromise;
};

class TurnstileWidget extends Component {
  constructor(props) {
    super(props);
    this.container = React.createRef();
    this.widgetId = null;
    this.isMountedFlag = false;
  }

  componentDidMount() {
    this.isMountedFlag = true;
    this.initialise();
  }

  componentWillUnmount() {
    this.isMountedFlag = false;
    if (window.turnstile && this.widgetId !== null) window.turnstile.remove(this.widgetId);
  }

  initialise = async () => {
    try {
      const response = await axios.get(`${apiHost}/api/auth/TurnstileConfiguration`);
      const siteKey = response.data && response.data.siteKey;
      if (!siteKey) throw new Error("Turnstile site key was not returned.");

      await loadTurnstileScript();
      if (!this.isMountedFlag || !window.turnstile || !this.container.current) return;

      this.widgetId = window.turnstile.render(this.container.current, {
        sitekey: siteKey,
        action: this.props.action,
        callback: this.props.onVerify,
        "expired-callback": this.props.onExpire,
        "error-callback": this.handleError,
      });
    } catch (e) {
      if (this.isMountedFlag) this.handleError();
    }
  };

  handleError = () => {
    if (this.props.onError) {
      this.props.onError("The security check could not be completed. Please try again.");
    }
  };

  reset = () => {
    if (window.turnstile && this.widgetId !== null) window.turnstile.reset(this.widgetId);
  };

  render() {
    return <div className="turnstileContainer" ref={this.container}></div>;
  }
}

export default TurnstileWidget;
